'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Error;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Error(_ref) {
  var error = _ref.error,
      label = _ref.label,
      noLabel = _ref.noLabel,
      complete = _ref.complete;

  if (!error) {
    return _react2.default.createElement('noscript', null);
  }
  if (!label && error.schema) {
    label = error.schema.label;
  }
  if (label && complete && !noLabel) {
    return _react2.default.createElement(
      'div',
      null,
      label,
      ': ',
      error.message
    );
  } else {
    return _react2.default.createElement(
      'div',
      null,
      error.message
    );
  }
} /**
   * @copyright 2015, Prometheus Research, LLC
   */
